import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { fetchRSOById, selectRSOsById } from "./slice"
import { calculateOrbitType } from "./orbit"

/**
 * Renders a resident space object for use as an item in a list
 */
const RSOOrbitRegime = ({ id }) => {
  const dispatch = useDispatch()
  const rsosByID = useSelector(selectRSOsById)
  const rso = rsosByID[id]

  useEffect(() => {
    dispatch(fetchRSOById(id))
  }, [id])

  return (
    <div>
      <span>
        {rso && calculateOrbitType(rso?.periapsis, rso?.apoapsis, rso.period)}
      </span>
    </div>
  )
}

RSOOrbitRegime.propTypes = {
  id: PropTypes.string, // The Norad id for the RSO
}

export default RSOOrbitRegime
